import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';

export const getIsValidCache = (cache, cacheVersion, state) => cache?.version === cacheVersion
  && cache?.locale === getActiveLocaleSelector(state);
